<template>
<v-card class="planner-layout__card plannerV2">
    <v-card-actions class="pa-0">
      <v-spacer></v-spacer>
      <!-- <a
      @click="handleToggleBackLogFilters"
      class="body-1 font-weight-bold d-inline pa-1"
      >
        <span>{{filtersBackLogToggle ? $t('planner.back') : $t('planner.filters')}}</span>
      </a> -->
    </v-card-actions>
    <!-- <v-card-title class="pa-0 text-center">
      <v-row no-gutters>
        <v-col>
           <span class="title">{{ state !== null ? computeHitsNumber : 0 }}</span>
        </v-col>
        <v-col>
          <span class="title" style="color: #9e9e9e;">{{$t('planner.drops')}}</span>
        </v-col>
      </v-row>
    </v-card-title> -->
    <v-list-item two-line class="text-center" style="max-height: 65px;">
      <v-list-item-content>
        <v-list-item-title class="title">{{ state !== null ? computeHitsNumber : 0 }}</v-list-item-title>
          <v-list-item-subtitle class="title">{{$t('planner.drops')}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col cols="12">
        <v-list ref="backlog" id="backlog" class="planner-layout__card--orders backlog draggable_list_backlog overflow-y-auto">
          <template v-show="computedHits.length > 0">
            <template v-for="drop in computedHits">
              <DropCompactItem
              :data-id="drop.id"
              :shipment-id="'backlog'"
              :dropID="drop.id"
              :key="drop.id"
              @drop:info="handleOpenInfo"
              />
            </template>
          </template>
          <!-- <template v-show="computeHitsFilter.length > 0">
             <template v-for="drop in computedHits">
              <DropCompactItem data-id="drop.objectID" :drop="drop" :key="drop.objectID"/>
            </template>
          </template> -->
        </v-list>
      </v-col>
    </v-row>
    <DropTransportsInfo :isOpen="dropInfoDialog" :dropID="dropInfoDropID" @close="dropInfoDialog = false" />
  </v-card>
</template>
<script>
import DropCompactItem from '@/components/planner/DropCompactItem.vue'
import DropTransportsInfo from '@/components/planner/DropTransportsInfo.vue'
import Sortable from 'sortablejs'
import { createWidgetMixin } from 'vue-instantsearch'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors/'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SortableInstanceBackLogDrops',
  components: {
    DropCompactItem,
    DropTransportsInfo
  },
  mixins: [
    createWidgetMixin({ connector: connectInfiniteHits })
  ],
  props: {
    handleToggleView: Function
  },
  data () {
    return {
      filtersBackLogToggle: false,
      sortableInstance: null,
      sortableElement: null,
      backLogCountItems: 0,
      dropInfoDialog: false,
      dropInfoDropID: null
    }
  },
  methods: {
    ...mapActions({
      removeDropsOnDestroy: 'removeDropsOnDestroy',
      setPlannerAlgoliaDrops: 'setPlannerAlgoliaDrops',
      movePlannerDropCardToBackLog: 'movePlannerDropCardToBackLog',
      plannerSetDropTransport: 'plannerSetDropTransport'
    }),
    initializeSortableInstance () {
      const _self = this
      this.sortableElement = document.querySelector('#backlog')
      this.sortableInstance = new Sortable(_self.sortableElement, {
        group: {
          name: 'planner',
          pull: true
        },
        ghostClass: 'drop-ghost',
        chosenClass: 'drop-ghost',
        forceFallback: true,
        dataIdAttr: 'data-id',
        delay: 50,
        fallbackTolerance: 5,
        animation: 150,
        fallbackOnBody: true,
        store: {
          get: (sortable) => {
            _self.backLogCountItems = sortable.toArray().length
            return _self.computedHits
          },
          set: (sortable) => {
            _self.backLogCountItems = sortable.toArray().length
          }
        },
        onAdd: ({ item, to, from, dragged, newIndex, oldIndex }) => {
          // _self.changeEventShipmentAutomergeDoc({
          //   shipmentID: 'backlog',
          //   fromShipmentID: from.getAttribute('id'),
          //   toShipmentID: 'backlog',
          //   newIndex,
          //   oldIndex,
          //   dropDetails: _self.planner.drops[item.getAttribute('data-id')],
          //   toDoc: null,
          //   lang: _self.$i18n.locale,
          //   toLocationsDetails: null,
          //   fromLocationsDetails: _self.planner.shipmentsLocations[from.getAttribute('id').replace('_backlog', '')],
          //   fromDoc: _self.getPlannerShipmentDoc(from.getAttribute('id').replace('_backlog', '')),
          //   toDocID: null,
          //   fromDocID: _self.getPlannerShipmentDocID(from.getAttribute('id').replace('_backlog', '')),
          //   userID: _self.cognito.user.username
          // })
          _self.movePlannerDropCardToBackLog({
            doc: _self.getPlannerDoc,
            oldShipmentID: item.getAttribute('shipment-id'),
            dropID: item.getAttribute('data-id')
          })
        },
        onEnd: ({ item, to, dragged, newIndex }) => {
          if (to.getAttribute('id') !== 'backlog') {
            item.parentNode.removeChild(item)
          }
        }
      })
    },
    handleToggleBackLogFilters () {
      this.filtersBackLogToggle = !this.filtersBackLogToggle
      const view = this.filtersBackLogToggle ? 'backlog_filters' : 'default'
      this.handleToggleView(view)
    },
    handleOpenInfo (dropID) {
      const drop = this.getPlannerDropByID(dropID)
      this.plannerSetDropTransport({ drop })
      this.dropInfoDropID = dropID
      this.dropInfoDialog = true
    },
  },
  computed: {
    ...mapGetters([
      'getPlannerDropsBackLog',
      'getPlannerDoc',
      'getPlannerDropByID'
    ]),
    computedHits: function () {
      return this.getPlannerDropsBackLog
    },
    computeHitsNumber () {
      if (this.filtersBackLogToggle) {
        return this.state.hits.length
      }
      return this.computedHits.length
    }
  },
  watch: {
    state: function (newState, oldState) {
      if (newState !== null) {
        this.setPlannerAlgoliaDrops({ drops: this.state.hits, shipmentIDs: this.$route.query.shipmentIDs })
        this.$nextTick(() => {
          this.initializeSortableInstance()
        })
      }
    }
  },
  beforeDestroy () {
    if (this.sortableInstance !== null) {
      this.removeDropsOnDestroy()
      this.sortableInstance.destroy()
    }
  }
}
</script>
<style lang="scss" scoped>
  .drop-ghost {
    opacity: 0.5;
  }
</style>
